enum ClassMode {
  Teacher = 'Teacher',
  Student = 'Student'
}

export default ClassMode;
